import React from "react"
import styled from "styled-components"

import Address from "../../../../_components/Address"
import Individual from "../Individual"
import Company from "../Company"
import { CreateBranchStateContext } from "../Create/Context"

import { Button, Typography, Steps, Card, InfoBox } from "../../../../design-system"
import { createBranch, getBranches } from "../../../../api/branches"
import { setCookieByName, getCookieByName } from "../../../../utils"
import { toast } from "react-toastify"
import { api, post, consts } from "@config"
import defaultUnits from "../../../../components/pages/products/utils/default-units"
import ProgressPanel from "./components/ProgressPanel"
import UploadDigitalCertificate from "../../../../components/pages/fiscal/digital-certificate/upload-certificate"
import { Modal } from "react-bootstrap"

const BranchTypeCard = ({ title, icon, selected, onClick }) => (
    <div style={{ cursor: "pointer", width: "240px", transition: "all 0.2s", transform: selected ? "translateY(-4px)" : "none" }} onClick={onClick}>
        <Card style={{ 
            borderColor: selected ? "#00A9FF" : "#EAECF0", 
            boxShadow: selected ? "0 4px 12px rgba(0, 169, 255, 0.2)" : undefined,
            backgroundColor: selected ? "#F0F9FF" : "#FFFFFF" 
        }}>
            <Card.Body>
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ gap: "1rem" }}>
                    <i className={`fa ${icon}`} style={{ fontSize: "3rem", color: selected ? "#00A9FF" : "#667085" }}></i>
                    <Typography variant="h5" color={selected ? "primary" : "dark"} style={{ fontWeight: 600 }}>{title}</Typography>
                </div>
            </Card.Body>
        </Card>
    </div>
)

const Container = styled.div`
    min-height: 80vh;
`

export default class CreateRefactored extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            address: {},
            errors: {},
            isLoading: false,
            progressStatus: "idle",
            progressValue: 0,
            showCertificateModal: false,
            step: "type",
            type: "",
        }
        this.onChangeBranchType = this.onChangeBranchType.bind(this)
        this.onChangeAddress = this.onChangeAddress.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.handleNextStep = this.handleNextStep.bind(this)
        this.handlePreviusStep = this.handlePreviusStep.bind(this)
        this.onSave = this.onSave.bind(this)
    }
    
    onChangeData(data) {
        this.setState({ ...this.state, data: { ...this.state.data, ...data } })
    }
    
    onChangeAddress(address) {
        this.setState({ ...this.state, address })
    }
    
    onChangeBranchType(type) {
        this.setState({ ...this.state, type })
    }
    
    handleNextStep() {
        let { step } = this.state
        if (step === "type") {
            step = "data"
        } else if (step === "data") {
            step = "address"
        }
        this.setState({ ...this.state, step })
        window.scrollTo({ top: 0 })
    }
    
    handlePreviusStep() {
        let { step } = this.state
        if (step === "address") {
            step = "data"
        } else if (step === "data") {
            step = "type"
        }
        this.setState({ ...this.state, step })
        window.scrollTo({ top: 0 })
    }

    onSave() {
        const { type, data, address } = this.state;
        const errors = {};

        if (!data.phone_number) errors.phone_number = "Este campo é obrigatório.";
        if (!data.crt && type !== "pf") errors.crt = "Selecione uma opção.";
        if (!data.email) errors.email = "Este campo é obrigatório.";

        if (Object.keys(errors).length > 0) {
            this.setState({ ...this.state, errors, step: "data" });
            toast.error("Preencha os campos obrigatórios.");
            return;
        }

        this.setState({ ...this.state, errors: {}, isLoading: true, progressStatus: "creating_branch", progressValue: 10 });

        const payload = {
            name: data.razaoSocial || "Nova Filial",
            phone_number: data.phone_number ? data.phone_number.replace(/\D/g, '') : "",
            email: data.email || "",
            branch: {
                aliquota_credito: 1,
                is_fiscal: true,
                branch_type: type === "pf" ? 1 : type === "pj" ? 2 : 3,
                main_company: true,
                crt: data.crt || 1
            },
            address: {
                street: address.street || "",
                street_number: address.street_number || "",
                complement: address.complement || "",
                district: address.district || "",
                postal_code: address.postal_code || "",
                city_location: address.city_id || null,
                state_location: address.state_id || null
            }
        };

        if (type !== "pf") {
            payload.company = {
                fancy_name: data.nomeFantasia || "",
                cnpj: data.cnpj ? data.cnpj.replace(/\D/g, '') : "",
                state_registry: data.inscricaoEstadual || "",
                municipal_registry: data.inscricaoMunicipal || "",
                main_cnae: data.cnae || "",
            };
        } else {
            payload.individual = {
                cpf: data.cpf ? data.cpf.replace(/\D/g, '') : ""
            };
            payload.branch.main_company = false;
        }

        createBranch(payload)
            .then(resp => {
                this.setState({ ...this.state, progressValue: 50, progressStatus: "adjusting" });

                // Dispara evento GTM/GA4 ao criar nova empresa/filial (Story #1559)
                if (typeof window !== "undefined" && window.dataLayer) {
                    window.dataLayer.push({
                        event: "novo_cadastro",
                        tipo: "empresa",
                        branch_type: this.state.type,
                    });
                }

                try {
                    let branches = window.localStorage.getItem(consts.ALL_BRANCHES);
                    branches = branches ? JSON.parse(branches) : [];
                    branches.push(resp);
                    
                    window.localStorage.removeItem(consts.ALL_BRANCHES);
                    window.localStorage.setItem(consts.ALL_BRANCHES, JSON.stringify(branches));

                    window.localStorage.removeItem(consts.CURRENT_BRANCH);
                    window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(resp));
                    
                    if (window.clientAPI && window.clientAPI._setCookie) {
                        window.clientAPI._setCookie('branch_owner_id', resp.id);
                        window.clientAPI._setCookie('branch_state_name', resp.address && resp.address.state ? resp.address.state : "");
                        window.clientAPI._setCookie('branch_owner_name', resp.individual ? resp.name : (resp.company ? resp.company.fancy_name : ""));
                    }

                    // Atualização síncrona imediata para evitar Race Condition com o redirecionamento
                    const currentCount = parseInt(getCookieByName("branch_count")) || 0;
                    setCookieByName("branch_count", currentCount + 1);

                    // Validação de segurança em background
                    getBranches().then(response => {
                        const activeBranches = response.filter(branch => branch.status !== 2);
                        setCookieByName("branch_count", activeBranches.length);
                    }).catch(e => console.error("Erro ao buscar branches para count", e));
                } catch (e) {
                    console.error("Erro ao atualizar storage", e);
                }

                this.setState({ ...this.state, progressValue: 65 });

                defaultUnits.forEach(unit => {
                    post(`${api.products.units}?branch_owner=${resp.id}`, unit, null);
                });

                const newCategoryPayload = _ => {
                    this.setState({ 
                        ...this.state, 
                        progressValue: payload.branch.is_fiscal ? 80 : 100, 
                        progressStatus: payload.branch.is_fiscal ? "waiting_certificate" : "done" 
                    });
                    
                    if (payload.branch.is_fiscal) {
                        setTimeout(() => (window.location.href = "/digital-certificate"), 5000);
                    } else {
                        setTimeout(() => (window.location.href = "/plans/select"), 5000);
                    }
                };

                post(
                    `${api.products.categories}?branch_owner=${resp.id}`,
                    { name: "Sem Categoria" },
                    newCategoryPayload
                );
            })
            .catch(error => {
                console.error("API Error: ", error);
                const apiErrors = {};
                
                if (error.phone_number) {
                    apiErrors.phone_number = error.phone_number[0] || "Telefone inválido.";
                }

                let errorStr = JSON.stringify(error);
                if (errorStr.includes("iugu_error") || errorStr.includes("não é válido")) {
                    apiErrors.phone_number = "Telefone inválido ou não aceito pela integradora (Iugu). Tente um número real.";
                }

                if (error.email) {
                    apiErrors.email = error.email[0] || "Email inválido.";
                }

                if (error.cnpj || (error.company && error.company.cnpj)) {
                    apiErrors.cnpj = "Verifique o CNPJ informado.";
                }

                if (Object.keys(apiErrors).length > 0) {
                    this.setState({ ...this.state, errors: apiErrors, step: "data", isLoading: false, progressStatus: "idle", progressValue: 0 });
                    toast.error("Verifique os campos destacados em vermelho.");
                } else {
                    toast.error("Erro ao cadastrar empresa. Verifique os dados.");
                    this.setState({ ...this.state, isLoading: false, progressStatus: "idle", progressValue: 0 });
                }
            });
    }

    handleCertificateSuccess = () => {
        this.setState({ ...this.state, progressValue: 100, progressStatus: "done", showCertificateModal: false });
    }

    componentDidMount() {
        this.onChangeBranchType("pj")
    }

    render() {
        const stepItems = [
            { title: "Tipo de filial" },
            { title: "Dados básicos" },
            { title: "Endereço" }
        ];
        
        let currentStepIndex = 0;
        if (this.state.step === "data") currentStepIndex = 1;
        if (this.state.step === "address") currentStepIndex = 2;

        return <CreateBranchStateContext.Provider value={this.state}>
            <Container className="container">
                <Modal show={this.state.progressStatus !== "idle"} backdrop="static" keyboard={false} centered contentClassName="bg-transparent border-0 shadow-none">
                    <Modal.Body className="p-0">
                        <ProgressPanel 
                            progressValue={this.state.progressValue}
                            progressStatus={this.state.progressStatus}
                            isFiscal={this.state.type !== "pf"}
                        />
                    </Modal.Body>
                </Modal>
                <Steps current={currentStepIndex} items={stepItems} />
                
                <div className={this.state.step === "type" ? "d-block" : "d-none"}>
                    <div className="col-12 mt-5 text-center d-flex flex-column align-items-center">
                        <Typography variant="h2" as="h1" className="mb-5" style={{ fontWeight: 800, color: '#101828' }}>
                            Vamos começar cadastrando sua empresa
                        </Typography>
                        <div className="d-flex justify-content-center py-4 flex-wrap" style={{ gap: "2.5rem" }}>
                            <BranchTypeCard 
                                title="Pessoa Física" 
                                icon="fa-user" 
                                selected={this.state.type === "pf"}
                                onClick={() => this.onChangeBranchType("pf")} 
                            />
                            <BranchTypeCard 
                                title="Pessoa Jurídica" 
                                icon="fa-building" 
                                selected={this.state.type === "pj"}
                                onClick={() => this.onChangeBranchType("pj")} 
                            />
                            <BranchTypeCard 
                                title="MEI" 
                                icon="fa-store" 
                                selected={this.state.type === "mei"}
                                onClick={() => this.onChangeBranchType("mei")} 
                            />
                        </div>
                        
                        <div className="d-flex flex-column align-items-center mt-5 gap-3">
                            <InfoBox
                                onClick={() => window.open("https://otimizeseunegocio.com/gestao-organizacao/certificado-digital-para-mei/", "_blank")}
                                icon="fa fa-question-circle"
                            >
                                <span style={{ fontSize: "14px", fontWeight: 500, color: "#00A9FF" }}>O que é Certificado Digital</span>
                            </InfoBox>
                            
                            <InfoBox
                                onClick={() => window.open("http://bit.ly/comprar-certificad-eg-web-up", "_blank")}
                                icon="fa fa-shopping-cart"
                            >
                                <span style={{ fontSize: "14px", fontWeight: 500, color: "#00A9FF" }}>Comprar Certificado Digital</span>
                            </InfoBox>
                        </div>
                    </div>
                </div>
                
                <div className={this.state.step === "data" ? "d-block" : "d-none"}>
                    <Individual show={this.state.type === "pf"} data={this.state.data} errors={this.state.errors} onChange={this.onChangeData} />
                    <Company 
                        show={this.state.type !== "pf"} 
                        data={this.state.data}
                        errors={this.state.errors}
                        onChange={this.onChangeData}
                        onAddressImport={(addr) => this.onChangeAddress({...this.state.address, ...addr})} 
                    />
                </div>
                
                <div className={this.state.step === "address" ? "d-block mt-4" : "d-none"}>
                    <Address 
                        data={this.state.address} 
                        onChange={this.onChangeAddress} 
                    />
                </div>
                
                <div className={this.state.step === "address" ? "row py-4" : "d-none"}>
                    <div className="col-4 col-xs-8 mx-auto">
                        <Button variant="success" size="lg" className="w-100" onClick={this.onSave} disabled={this.state.isLoading}>
                            {this.state.isLoading ? "Salvando..." : "Finalizar"}
                        </Button>
                    </div>
                </div>
                
                <div className="row py-4 mt-2">
                    <div className="col-md-6">
                        <Button
                            variant="secondary"
                            className="px-5"
                            disabled={this.state.step === "type"}
                            onClick={this.handlePreviusStep}>
                            Anterior
                        </Button>
                    </div>
                    <div className={this.state.step === "address" ? "d-none" : "col-md-6 d-flex justify-content-end"} >
                        <Button
                            variant="primary"
                            className="px-5"
                            disabled={this.state.step === "address"}
                            onClick={this.handleNextStep}>
                            Próximo
                        </Button>
                    </div>
                </div>
            </Container>
        </CreateBranchStateContext.Provider>
    }
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/CreateRefactored/index.jsx